import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ComingSoon } from '@/components/common/coming-soon'

const usedVehicleSellerSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute(
  '/_authenticated/used-vehicle-seller/contact-ops/'
)({
  validateSearch: usedVehicleSellerSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/used-vehicle-seller/contact-ops',
        search: { language: 'en' },
      })
    }
  },
  component: () => <ComingSoon title='Used Vehicle Seller' />,
})
